<template>
  <div class="report-time-edit">
    <v-dialog
      v-model="isVisible"
      max-width="302"
      transition="dialog-transition"
      @input="clearForm"
    >
      <v-card>
        <v-card-title
          class="report-time-edit__title headline"
          primary-title
        >
          ADD/EDIT TIME
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-row class="report-time-edit__row">
            <v-col class="report-time-edit__col" cols="12">
              <v-text-field
                :value="currentMonth"
                class="report-time-edit__month form-field"
                dense
                disabled
                label="Month"
                placeholder="Current month"
              />
            </v-col>
          </v-row>

          <v-form ref="timeForm" v-model="isFormValid" @submit.prevent="submitForm">
            <v-row class="report-time-edit__row">
              <v-col class="report-time-edit__col" cols="12">
                <v-text-field
                  v-model="formattedTime"
                  class="form-field"
                  :rules="[rules.required, rules.time]"
                  dense
                  label="Hours*"
                  placeholder="HH:MM:SS"
                />
              </v-col>
              <v-col class="report-time-edit__col" cols="12">
                <v-text-field
                  v-model="newReport.rate"
                  class="form-field"
                  :rules="[rules.required, rules.positive]"
                  dense
                  label="Rate*"
                  placeholder="Type hourly rate..."
                  suffix="PLN / h"
                  type="number"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="report-time-edit__actions">
          <v-btn
            class="report-time-edit__submit"
            color="blue"
            large
            dark
            :loading="isSubmitProcessing"
            @click="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    month: {
      type: String,
      required: false,
      default: '',
    },
    report: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      timeSeonds: '0',
      newReport: {
        time_worked_in_seconds: '0',
        rate: '',
      },
    };
  },

  computed: {
    ...mapState('hrProject', [
      'isSubmitProcessing',
    ]),

    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    currentMonth() {
      return this.month;
    },

    formattedTime: {
      get() {
        let seconds = parseInt(this.newReport.time_worked_in_seconds, 10);
        let hours = Math.floor(seconds / 3600);
        let minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);
        if (hours < 10) hours = `0${hours}`;
        if (minutes < 10) minutes = `0${minutes}`;
        if (seconds < 10) seconds = `0${seconds}`;
        const time = `${hours}:${minutes}:${seconds}`;

        return time;
      },
      set(timeString) {
        if (timeString) {
          let hours = 0;
          let minutes = 0;
          let seconds = 0;
          const timeArray = timeString.split(':');

          // eslint-disable-next-line no-restricted-globals
          if (timeArray[0] && !isNaN(timeArray[0])) {
            hours = parseInt(timeArray[0], 10) * 3600;
          }
          // eslint-disable-next-line no-restricted-globals
          if (timeArray[1] && !isNaN(timeArray[1])) {
            minutes = parseInt(timeArray[1], 10) * 60;
          }
          // eslint-disable-next-line no-restricted-globals
          if (timeArray[2] && !isNaN(timeArray[2])) {
            seconds = parseInt(timeArray[2], 10);
          }
          const timeInSeconds = hours + minutes + seconds;

          this.timeSeonds = parseInt(timeInSeconds, 10);
        }
      },
    },
  },

  watch: {
    isVisible() {
      this.newReport = this.isVisible ? { ...this.report } : {
        time_worked_in_seconds: 0,
        rate: '',
      };
    },
  },

  methods: {
    ...mapActions('hrProject', [
      'updateProjectReport',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    clearForm() {
      this.$refs.timeForm.resetValidation();
      this.newReport = {
        time_worked_in_seconds: '',
        rate: '',
      };
    },

    setTimeInSecondsToRaport() {
      this.newReport.time_worked_in_seconds = this.timeSeonds;
    },

    submit() {
      this.$refs.timeForm.validate();

      if (this.isFormValid) {
        this.setTimeInSecondsToRaport();
        this.updateProjectReport({ id: this.report.id, data: this.newReport })
          .then(() => {
            this.$emit('change');
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss">
.report-time-edit {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__row {
    margin-right: -8px;
    margin-left: -8px;
    margin-bottom: 8px;
  }
  &__col {
    padding: 0 8px 8px;
  }

  &__month {
    &.form-field.v-text-field > .v-input__control > .v-input__slot {
      background: #E2E6EA;
      color: $main--text;
    }
  }

  &__actions {
    margin-top: 32px;
  }

  &__submit {
    width: 100%;
  }
}
</style>
